import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AdminAuthContext } from "./context/AdminAuthContext";
import { PrimaryButton, ThemeToggle } from "../design-system";
import { typography, borders, surfaces, textColors } from "../design-system/tokens";
import { FormField, Input } from "../design-system/components/inputs";

const AdminLogin = () => {
  const { adminLogin } = useContext(AdminAuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await adminLogin(username, password);
      navigate("/admin/dashboard/dashboard");
    } catch (err) {
      setError(err.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`min-h-screen ${surfaces.modernApp} flex items-center justify-center px-4 relative`}>
      {/* Theme Toggle - Fixed top right */}
      <div className="fixed top-6 right-6">
        <ThemeToggle />
      </div>

      <div className={`w-full max-w-md ${surfaces.glassCard} ${borders.glass} border rounded-2xl p-8 shadow-lg`}>
        <h2 className={`${typography.h2} ${textColors.primary} mb-2 text-center`}>
          Admin Dashboard
        </h2>
        <p className={`${typography.body} ${textColors.secondary} mb-6 text-center`}>
          Sign in to access the admin panel
        </p>

        {error && (
          <div className="mb-4 p-3 bg-red-100 dark:bg-red-900/30 border border-red-400 dark:border-red-600 text-red-700 dark:text-red-300 rounded-md text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <FormField label="Username" htmlFor="username" required>
            <Input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter admin username"
              required
              disabled={loading}
            />
          </FormField>

          <FormField label="Password" htmlFor="password" required>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
              disabled={loading}
            />
          </FormField>

          <PrimaryButton
            type="submit"
            variant="gradient"
            fullWidth={true}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </PrimaryButton>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;

